import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import "./SelectDate.scss";
import messages from "../../assets/i18n";
import { DateLabel } from "../Labels";
import moment from 'moment';

/**
 * Componente para selecionar um dia da semana
 */

function SelectDate(props) {

    const [date, setDate] = useState(null)
    const lang = useSelector(state => state.language.name)

    const handleClick = (dateSelect, day) => {
        const { functionProps } = props;
        if (date !== dateSelect) {
            setDate(dateSelect);
            if (functionProps !== undefined) functionProps(dateSelect, day);
        }
    };

    const { days } = props;

    if (days === undefined) {
        return <h3>{messages[lang].noDaysHasBeenPassed}</h3>;
    } else if (Object.keys(days).length <= 0) {
        return <h3>{messages[lang].loading}</h3>;
    } else {
        return (
            <ul className="list-inline select-date-component">
                {Object.keys(days).map((day, i) => {
                    const disabled = days[day].hours.length <= 0 ? " disabled" : "";
                    const active = date === days[day].date ? " active" : "";
                    return (
                        <li
                            key={i}
                            className={`list-inline-item${active}${disabled}`}
                            onClick={() => handleClick(days[day].date, day)}
                            id={`select-date-${day}`}
                        >
                            <span className="weekday">
                                {messages[lang][day]}
                            </span>
                            <div className="span-date">
                                {
                                days[day].date &&
                                    <DateLabel 
                                        date={moment(days[day].date).toDate()}
                                        dayMouth
                                    />
                                }
                            </div>
                        </li>
                    );
                })}
            </ul>
        );
    }
}

SelectDate.propTypes = {
    days: PropTypes.object,
    functionProps: PropTypes.func
};

export default SelectDate;
